import React, { useEffect, useState } from "react";
import { Card, CardBody, CardTitle, Col, Row } from "reactstrap";
import { getAllProjects } from "../../services/ValitanApiService";

const ProjectStatus = () => {
    const [statusCounts, setStatusCounts] = useState({});
    const [totalProjects, setTotalProjects] = useState(0);

    useEffect(() => {
        fetchAllProjects();
    }, []);

    const fetchAllProjects = async () => {
        try {
            let allProjects = [];
            let page = 0;
            let size = 100;
            let hasMore = true;

            while (hasMore) {
                const response = await getAllProjects(page, size);
                const content = response?.data?.content || [];
                allProjects = [...allProjects, ...content];

                hasMore = content.length === size;
                page++;
            }

            const grouped = allProjects.reduce((acc, project) => {
                const status = project.status || "UNKNOWN";
                acc[status] = (acc[status] || 0) + 1;
                return acc;
            }, {});

            setStatusCounts(grouped);
            setTotalProjects(allProjects.length);
        } catch (error) {
            // ❌ no snackbar here → handled globally in apiClient
            console.error("Error fetching project status:", error);
        }
    };

    const getProgress = (count) => {
        return totalProjects > 0 ? ((count / totalProjects) * 100).toFixed(2) : 0;
    };

    const statusColorMap = {
        IN_PROGRESS: "info",
        COMPLETED: "success",
        PLANNED: "warning",
        CANCELLED: "danger",
        UNKNOWN: "secondary",
    };

    return (
        <React.Fragment>
            <Col xl={4}>
                <Card>
                    <CardBody>
                        <CardTitle>Projects Status</CardTitle>
                        <ul className="list-unstyled">
                            {Object.entries(statusCounts).map(([status, count]) => (
                                <li key={status} className="py-3">
                                    <div className="d-flex">
                                        <div className="avatar-xs align-self-center me-3">
                                            <div className="avatar-title rounded-circle bg-light text-primary font-size-18">
                                                <i className="ri-folder-line"></i>
                                            </div>
                                        </div>
                                        <div className="flex-grow-1">
                                            <p className="text-muted mb-2">{status.replace("_", " ")}</p>
                                            <div className="progress progress-sm animated-progess">
                                                <div
                                                    className={`progress-bar bg-${statusColorMap[status] || "secondary"}`}
                                                    role="progressbar"
                                                    style={{ width: `${getProgress(count)}%` }}
                                                    aria-valuenow={getProgress(count)}
                                                    aria-valuemin="0"
                                                    aria-valuemax="100"
                                                ></div>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            ))}
                        </ul>

                        <hr />

                        <div className="text-center">
                            <Row>
                                {Object.entries(statusCounts).map(([status, count]) => (
                                    <div key={status} className="col-4">
                                        <div className="mt-2">
                                            <p className="text-muted mb-2">{status.replace("_", " ")}</p>
                                            <h5 className="font-size-16 mb-0">{count}</h5>
                                        </div>
                                    </div>
                                ))}
                            </Row>
                        </div>
                    </CardBody>
                </Card>
            </Col>
        </React.Fragment>
    );
};

export default ProjectStatus;
